/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled, { css } from "styled-components";

export type BoxProps = {
  inline?: boolean;
  radius?: string;
  color?: string;
  padding?: string;
  margin?: string;
  size?: string;
  border?: string;
};

export const Box = styled.div<BoxProps>`
  border-radius: 0.25rem;
  ${handleStylesFromProps};
`;

function handleStylesFromProps(props: BoxProps) {
  return css({
    ...(props.inline != null && {
      display: "inline-block",
    }),
    ...(props.radius != null && {
      borderRadius: props.radius,
    }),
    ...(props.color != null && {
      backgroundColor: props.color,
    }),
    ...(props.padding != null && {
      padding: props.padding,
    }),
    ...(props.margin != null && {
      margin: props.margin,
    }),
    ...(props.size != null && {
      width: props.size,
      height: props.size,
    }),
    ...(props.border != null && {
      border: `1px solid ${props.border};`,
    }),
  });
}
